import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import company_image from '../../../shared/assets/svg/landscape-placeholder.svg';
import Button from '../../../shared/components/ui/Button';
import { useMutation } from '@tanstack/react-query';
import { deleteCompany, handleCheckCompanyDelete } from '../../services/api/implementation/impl';
import toast from 'react-hot-toast';
import Modal from '../../../shared/components/ui/Modal';
import DeleteConfirmationModal from './DeleteConfirmationModal';
import deleteIcon from '../../../shared/assets/svg/delete.svg';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';

const CompanyCard = ({ data, AllData, refresh }) => {
  const userId = Cookies.get('userId');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [canDelete, setCanDelete] = useState(null);
  const [resData, setResData] = useState();
  const [selectedIds, setSelectedIds] = useState([]);

  const navigate = useNavigate();

  const handleViewCompany = () => {
    if (data?.id) {
      navigate(`/builder/management/company/${data.id}`);
    }
  };

  const handleViewProjects = () => {
    if (data?.id) {
      navigate(`/builder/management/company/${data.id}/projects`);
    }
  };

  // Safely access the logo URL, fallback to default image if not available
  const logoUrl = data?.company_logo?.[0]?.url || company_image;

  //delete functions

  const { mutate: handleCheckDelete } = useMutation({
    mutationFn: (id) => handleCheckCompanyDelete(id),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async (res, id) => {
      setIsSubmitting(false);
      const company = AllData?.find((item) => parseInt(item.id) === parseInt(id));
      const companyName = company?.company_name || 'company';
      if (res.canDelete) {
        setCanDelete('yes');
        setResData({ name: companyName });
        setSelectedIds([parseInt(id)]);
      } else {
        // Fallback if not found
        setResData({ ...res, name: companyName });
        setCanDelete('no');
      }
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error checking dependencies', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error checking dependencies');
    }
  });

  const { mutate: handleDeleteFn } = useMutation({
    mutationFn: (payload) => deleteCompany(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: () => {
      setIsSubmitting(false);
      toast.success('Company Deleted Successfully');
      refresh?.();
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error deleting company', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error deleting company');
    }
  });

  const HandleDelete = (data) => {
    const payload = { ids: data };
    handleDeleteFn(payload);
  };

  return (
    <div className="bg-white w-[31%] p-6 rounded-xl flex flex-col gap-4 flex-shrink-0 relative">
      {canDelete === 'no' && (
        <Modal
          isDirty={true}
          confirmOnClose={false}
          name={`Cannot delete '${resData?.name || 'this company'}'`}
          onClose={() => setCanDelete(null)}
          width={45}>
          <div className="flex flex-col justify-center align-center ">
            <p className="text-center">
              Looks like this company has dependencies, please delete following lands and projects
              to proceed
            </p>
            <div className="flex justify-start, align-middle flex-wrap bg-[#f5f7f8] p-2 rounded-[5px] mt-4">
              {resData &&
                resData.reason?.map((r, index) => (
                  <span className="mt-[2px] mr-[4px] text-[#535353]" key={index}>
                    {index + 1}.{r}
                    {index < resData.reason.length - 1 ? ', ' : ''}
                  </span>
                ))}
            </div>
          </div>
        </Modal>
      )}

      {canDelete === 'yes' && (
        <Modal
          isDirty={true}
          confirmOnClose={false}
          name={'Confirmation'}
          onClose={() => {
            setCanDelete(null);
            setSelectedIds([]);
          }}
          width={45}>
          <DeleteConfirmationModal
            name={resData.name}
            title={'company'}
            onClose={() => setCanDelete(null)}
            data={AllData}
            type={'company'}
            setCanDelete={setCanDelete}
            onDeleteClick={HandleDelete}
            setSelectedIds={setSelectedIds}
            selectedIds={selectedIds}
          />
        </Modal>
      )}
      <img
        src={logoUrl}
        alt="Company logo"
        className="w-full h-64 bg-center bg-cover object-contain bg-gray-100 rounded-lg object-center cursor-pointer hover:opacity-80 transition-opacity"
        onClick={handleViewProjects}
      />

      <button
        className="bg-[#f7f5f5] w-[fit-content] p-1 rounded-full cursor-pointer absolute top-2 right-2"
        onClick={() => handleCheckDelete(data.id)}
        disabled={!data?.id || isSubmitting}>
        <img src={deleteIcon} />
      </button>

      <span className="text-xl font-semibold text-gray-700">
        {data?.company_name || 'Company Name Not Available'}
      </span>

      <span className="mt-[-8px] text-gray-400">
        {data?.company_type ? `${data.company_type} Company` : 'Company Type Not Specified'}
      </span>

      <div className="flex justify-between items-center space-x-2 mt-2">
        <Button displayType="secondary" onClick={handleViewCompany} disabled={!data?.id}>
          View Company
        </Button>
        <Button onClick={handleViewProjects} disabled={!data?.id}>
          View Projects
        </Button>
      </div>
    </div>
  );
};

export default CompanyCard;
